import service from '../../ajax/service';
import language from '../../js/language';
import $ from "jquery";
import { getText } from '../../js/main';

const index = {
    render() {
        // 渲染下载链接信息
        this.renderGameInfo();
    },
    renderGameInfo() {
        const gameID = language.gameID;
        service
            .getGameInfo(gameID)
            .then(({ data }) => {
                const tipText = `javascript: alert("${getText('wait')}")`;
                $('.j-apple-down').attr('href', data.appStoreDownLoadURL || tipText);
                $('.j-google-down').attr('href', data.googlePlayDownLoadURL || tipText);
                $('.j-apk-down').attr('href', data.apkDownLoadURL || tipText);
            })
            .catch(err => {
                console.log(err);
            });
    },
};

export default index;
